import styled from '@emotion/styled'

export const SubTitleForm = styled.h4`
  margin: 30px 0 0;
`
